import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const streportsApi = createApi({
  reducerPath: 'streportsApi',
  baseQuery: btBaseQuery,
  tagTypes: ['STReports'],
  keepUnusedDataFor: 10,

  endpoints: (builder) => ({
    getSTPurchases: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/purchases/${cid}/${fdt}/${tdt}`
    }),
    getSTIssues: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/issues/${cid}/${fdt}/${tdt}`
    }),
    getSTIssuesPend: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/issuespend/${cid}/${fdt}/${tdt}`
    }),
    getSTStocks: builder.query<any, any>({
      query: ({ cid, fdt, tdt }) => `streports/stock/${cid}/${fdt}/${tdt}`
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetSTPurchasesQuery,
  useGetSTIssuesQuery,
  useGetSTIssuesPendQuery,
  useGetSTStocksQuery
} = streportsApi;
